import { AxiosRequestConfig, AxiosResponse } from "axios";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { API } from "redux/actions/types";

interface ApiPayload extends Partial<AxiosRequestConfig> {
    url: string;
    method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
    data?: any;
    onSuccess?: (data: AxiosResponse["data"], response: AxiosResponse) => any;
    onFailure?: (error: AxiosResponse) => any,
    onFinish?: () => any,
    onBefore?: () => any,
    getValidation?: (errors: Record<string, string>) => any
    onError?: (error: any) => any,
    muted?: boolean,
    /** Skips the error toast for responses the caller handles itself, e.g. a 422 it answers with a dialog. */
    muteWhen?: (response: AxiosResponse) => boolean,
    toastCallback?: () => any,
    /** Hand a 401 to `onFailure` instead of logging out and leaving the page. */
    keepSessionOnUnauthorized?: boolean,
}

export const useApi = () => {
    const dispatch = useDispatch();

    // Stable across renders, because `api` sits in effect dependency lists all
    // over the app — and a fresh identity per render turned every one of those
    // effects into a request per render. The visible symptom was a stale 404:
    // a modal re-rendered right after moving its subject and refetched it under
    // the old ids. `dispatch` itself is stable, so this changes nothing else.
    return useCallback((payload: ApiPayload) => {
        return new Promise<any>((resolve) => {
            dispatch({
                type: API,
                payload: {
                    ...payload,
                    onError: (error: any) => {
                        resolve(error);
                        if (payload.onError) payload.onError(error);
                    }
                }
            });
        });
    }, [dispatch]);
};
